module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.submitted) ? _c('div', {
    staticClass: "dashboard-password"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Something about reseting your password")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "dashboard-password",
      "fields": _vm.resetPassword,
      "button-size": "m",
      "button": "primary",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1) : _c('div', {
    staticClass: "dashboard-password"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Your password has been reset")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Something about reseting your password")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "level": "secondary",
      "label": "Got It",
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showForm()
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e6591c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/Password.vue
// module id = 335
// module chunks = 0